import { type FlexProps } from '@chakra-ui/react';
import { NormalTokenSelector } from '@ui/components/SwapDialog/NormalTokenSelector';
import { Token } from '@ui/config/token';
import { isTokenOnBonding } from '@ui/config/token/types';

import { useBondingTradeForm } from './useBondingTradeForm';

interface BondingNormalTokenSelectorProps extends FlexProps {
  isSelectable?: boolean;
}

export const BondingNormalTokenSelector = ({
  isSelectable = true,
  ...props
}: BondingNormalTokenSelectorProps) => {
  const fromToken = useBondingTradeForm((s) => s.fromToken);
  const toToken = useBondingTradeForm((s) => s.toToken);

  const onSelectToken = (newToken: Token) => {
    if (!isTokenOnBonding(newToken)) return;
    if (fromToken !== Token.Bonding) {
      useBondingTradeForm.setState({ fromToken: newToken });
    } else {
      useBondingTradeForm.setState({ toToken: newToken });
    }
  };

  return (
    <NormalTokenSelector
      isSelectable={isSelectable}
      fromToken={fromToken}
      toToken={toToken}
      onSelectToken={onSelectToken}
      {...props}
    />
  );
};
